import { connect } from 'react-redux';
import Screen from '../components/Screen.jsx';

const mapStateToProps = (state, props) => {
  return Object.assign({
    folderId: props.match.params.folderId,
    currentDeckId: state.decks.currentDeckId
  });
};

export default connect(mapStateToProps, null)(Screen);
